import { useEffect, useState } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const [time, setTime] = useState("");

  useEffect(() => {
    const tick = () =>
      setTime(new Intl.DateTimeFormat("en-US", { hour: "2-digit", minute: "2-digit", timeZone: "America/New_York" }).format(new Date()));
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <footer id="contact" data-testid="footer-section" className="border-t border-[#e8e5e0] bg-[#f4f1ec] pt-16 pb-4 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logos/emberline-final-512.png" alt="Emberline Chimney Co. logo" className="w-20 h-20 object-contain" />
            <div>
              <p className="font-tech font-semibold tracking-[0.22em] text-neutral-900">EMBERLINE</p>
              <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#ff6b00]">Chimney Co.</p>
            </div>
          </div>
          <p className="text-sm text-neutral-500 max-w-sm leading-relaxed font-display italic">{t.footer.tagline}</p>
        </div>

        <div className="md:col-span-3">
          <p className="font-tech text-xs tracking-[0.3em] uppercase text-neutral-400 mb-4">{t.footer.contactTitle}</p>
          <ul className="space-y-3 text-sm text-neutral-600">
            <li className="flex items-start gap-2.5"><MapPin size={15} className="text-[#ff6b00] mt-0.5 shrink-0" /> {t.footer.address}</li>
            <li className="flex items-center gap-2.5"><Phone size={15} className="text-[#ff6b00] shrink-0" /> <a href="tel:+12162784778" data-testid="footer-phone-link" className="hover:text-[#ff6b00] transition-colors">(216) 278-4778</a></li>
            <li className="flex items-center gap-2.5"><Mail size={15} className="text-[#ff6b00] shrink-0" /> <a href="mailto:emberlinechimney@gmail.com" className="hover:text-[#ff6b00] transition-colors">emberlinechimney@gmail.com</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="font-tech text-xs tracking-[0.3em] uppercase text-neutral-400 mb-4">{t.footer.hoursTitle}</p>
          <ul className="space-y-3 text-sm text-neutral-600">
            <li className="flex items-center gap-2.5"><Clock size={15} className="text-[#ff6b00] shrink-0" /> {t.footer.hours1}</li>
            <li className="flex items-center gap-2.5"><Clock size={15} className="text-red-400 shrink-0" /> {t.footer.hours2}</li>
          </ul>
          <div className="mt-6 flex gap-4">
            <Link to="/admin" data-testid="footer-admin-link" className="font-tech text-xs tracking-widest uppercase text-neutral-400 hover:text-[#ff6b00] transition-colors">Admin</Link>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 mt-12 pt-6 border-t border-[#e3dfd8] flex flex-wrap justify-between gap-2">
        <p className="font-tech text-[11px] tracking-widest text-neutral-400">© {new Date().getFullYear()} Emberline Chimney Co. {t.footer.rights}</p>
        <p data-testid="footer-local-time" className="font-tech text-[11px] tracking-widest text-neutral-400 flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-[#ff6b00] animate-pulse" /> Cleveland, OH — {time}
        </p>
      </div>

      <p className="text-center font-display font-bold text-[14vw] leading-[0.85] text-outline select-none whitespace-nowrap overflow-hidden -mb-6 mt-8" aria-hidden="true">
        EMBERLINE
      </p>
    </footer>
  );
};
